// extracted by mini-css-extract-plugin
module.exports = {"page":"UserNotifications_page__GEkOo","content":"UserNotifications_content__xcCAQ"};